<template>
  <v-dialog
    persistent
    v-model="dialog"
    style="display: flex; justify-content: center; align-items: center;"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="headline">Ajustar Imagem</v-card-title>
      <v-card-text class="ma-0 pb-0">
        <cropper
          class="cropper"
          :src="image.image.original"
          :stencil-props="{ aspectRatio: 1 }"
          @change="change"
        />

        <!-- Vincula o campo de descrição com a propriedade description -->
        <v-text-field
          class="mt-2 mb-0"
          label="Descrição"
          dense
          outlined
          v-model="description"
        />

      </v-card-text>
      <v-card-actions class="pl-6 pt-0">
        <v-btn variant="text" @click="closeModal">Cancelar</v-btn>
        <v-btn color="primary" @click="savePosition">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Vue from "vue";

export default {
  props: {
    value: Boolean,
    image: Object,
  },
  components: {
    Cropper,
  },
  data() {
    return {
      isValid: true,
      description: this.image.description || "", // Inicializa com a descrição existente ou vazio
      rules: {
          required: v => !!v || "Campo obrigatório", // Regra de validação
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    change({ coordinates, canvas }) {
      this.croppedImage = canvas.toDataURL();
    },

    async savePosition() {

      // Atualiza a descrição junto com a imagem recortada

      console.log(this.image.image)

      const imageResponse = await Vue.prototype.$http.post('/Entity/RIDImagens', {
        "image": [
            {
              "fileName": this.image.image.fileName,
              "base64": this.croppedImage
            }
        ],
        "description": this.description
      })

      this.$emit("ids", {
        id: imageResponse.data.data.id
      })

      this.$emit("image-updated", {
        croppedImage: this.croppedImage,
        description: this.description, // Passa a descrição para o método de atualização
      });

      this.closeModal();

    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cropper {
  width: 100%;
  max-width: 500px;
  background: #DDD;
}
.v-dialog__content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
  width: 100%;
  z-index: 6;
  outline: none;
}
</style>
